import React, { useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { chatTheme } from '../../theme/chatTheme';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

const MessageList = ({ messages, currentUserId, userType, chatId, isLoading, isTyping, chatContext, currentUserName }) => {
  const messagesEndRef = useRef(null);
  const isInitialMount = useRef(true);
  const prevMessagesLength = useRef(0);
  
  useEffect(() => {
    // Use instant scroll for new messages, smooth only for initial load
    const isNewMessage = messages.length > prevMessagesLength.current;
    const shouldSmoothScroll = isInitialMount.current || !isNewMessage;
    
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ 
        behavior: shouldSmoothScroll ? 'smooth' : 'auto',
        block: 'end'
      });
    }
    
    prevMessagesLength.current = messages.length;
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
  }, [messages, isTyping]);
  
  if (isLoading) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }
  
  return (
    <Box sx={chatTheme.messageList}>
      {messages.length === 0 ? (
        <Box
          sx={{
            flex: 1,
            minHeight: { xs: 120, md: 0 },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            color: 'text.secondary',
          }}
        >
          <Typography variant="body1" sx={{ mb: 1 }}>
            {userType === 'supplier'
              ? 'You will see messages here when couples reach out'
              : 'No messages yet'}
          </Typography>
          {userType !== 'supplier' && (
            <Typography variant="caption">
              Start the conversation!
            </Typography>
          )}
        </Box>
      ) : (
        <>
          {messages.map((message) => (
            <MessageBubble
              key={message._id || message.timestamp}
              message={message}
              currentUserId={currentUserId}
              userType={userType}
              chatId={chatId}
              chatContext={message.chatContext || chatContext}
              currentUserName={currentUserName}
            />
          ))}
          {/* Typing indicator - only show for non-supplier users (suppliers have custom indicator) */}
          {isTyping && userType !== 'supplier' && <TypingIndicator />}
          <div ref={messagesEndRef} />
        </>
      )}
    </Box>
  );
};

export default MessageList;

